// extracted by mini-css-extract-plugin
export default {"container":"PhoneInput_container__TO051","input":"PhoneInput_input__q60Ek"};